import { BaseEntity } from "@app/common";
import { UnitPrice } from "@app/core";
import { prop, propObject, required } from "@messaia/cdk";
import { DisplayOption } from "../enums/display-option";
import { ProductCategory } from "../enums/product-category";
import { ProductType } from "../enums/product-type";
import { ResellerProductType } from "../enums/resellter-product-type";
import { ProductDetails } from "./product-details";

export class BundleProduct extends BaseEntity {
	@prop()
	id: number;

	@prop()
	bundleId: number;

	@required()
	productType: ProductType;

	@required()
	resellerProductType: ResellerProductType;

	@required()
	productCategory: ProductCategory;

	@required()
	externalId: number = 0;

	@prop()
	externalAltId: string;

	@required()
	name: string;

	@prop()
	nameIntern: string;

	@prop()
	description: string;

	@prop()
	imagePath: string;

	@prop()
	image: string;

	@prop()
	thumnb: string;

	@prop()
	tariffId: number;

	@required()
	productId: number;

	@prop()
	internalQuantity: number = 1;

	@prop()
	nameFootnote: string;

	@prop()
	speedReduction: boolean;

	@required()
	displayOption: DisplayOption = DisplayOption.TariffOverview;

	@propObject(UnitPrice)
	regularPrice: UnitPrice = new UnitPrice();

	@propObject(UnitPrice)
	reducedPrice: UnitPrice = new UnitPrice();

	@propObject(UnitPrice)
	shippingCost: UnitPrice = new UnitPrice();

	@prop()
	ordering: number;

	@propObject(ProductDetails)
	details: ProductDetails = new ProductDetails();

	/**
	 * constructor
	 * @param init 
	 */
	public constructor(init?: Partial<BundleProduct>) {
		super(init);
		Object.assign(this, init);
	}
}